import { rawClient } from "../../../../ajax";
import {
  sendingRequest,
  receivedResponse,
  createAction
} from "../../../../redux_util";
import formatError from "../../../../formatErrors";

export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";

export const userLoginSuccess = createAction(
  USER_LOGIN_SUCCESS,
  "authToken",
  "appUser",
  "message"
);
export const userLogin = data => {
  return dispatch => {
    dispatch(sendingRequest("userLogin"));
    return rawClient
      .post(`login`, data)
      .then(res => {
        dispatch(receivedResponse("userLogin"));
        return dispatch(
          userLoginSuccess(
            res.headers["authorization"] || "",
            res.data,
            "Login Successful"
          )
        );
      })
      .catch(err => {
        return dispatch(receivedResponse("userLogin", formatError(err)));
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/screens/Login/redux/actions.js